//Built-in libraries

//Third party libraries

//Custom components
import Button from '@/components/UI/Button';
import { HookCheckbox } from '@/components/UI/HookForm/Form/Checkbox';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function Scope() {
  const { setCurrentStep } = useApplicationFormContext();
  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>Scope</h3>
        <div className='my-5 font-semibold'>
          <h4>Services to be provided at property</h4>
        </div>
        <div className='grid grid-cols-1 h-screen/4'>
          <HookCheckbox name='scope.roofing' id='scope.roofing' className='col-span-1'>
            <label htmlFor='roofing'>Roofing</label>
          </HookCheckbox>

          <HookCheckbox name='scope.plumbing' id='scope.plumbing' className='col-span-1'>
            <label htmlFor='plumbing'>Plumbing</label>
          </HookCheckbox>

          <HookCheckbox name='scope.electrical' id='scope.electrical' className='col-span-1'>
            <label htmlFor='electrical'>Electrical</label>
          </HookCheckbox>

          <HookCheckbox name='scope.heatAndAir' id='scope.heatAndAir' className='col-span-1'>
            <label htmlFor='heat-Air'>Heat & Air</label>
          </HookCheckbox>

          <HookCheckbox name='scope.structural' id='scope.structural' className='col-span-1'>
            <label htmlFor='structural'>Structural</label>
          </HookCheckbox>

          <HookCheckbox name='scope.painting' id='scope.painting' className='col-span-1'>
            <label htmlFor='painting'>Painting</label>
          </HookCheckbox>
        </div>

        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </div>
  );
}
